<script lang="typescript">
    import { fade } from 'svelte/transition';
    
    </script>

    <div in:fade={{delay:400, duration:400}} out:fade={{duration: 400}} class="editingContainer">
        <div class="editorContainer">
            <div class="editor activeEditor" id="copyOutline">
                <div class="outlinePart">
                    <h2>
                        I. LEAD
                    </h2>
                    <ul>
                        <li>
                            Call Out Problem
                        </li>
                        <li>
                            Promise Solution to Pain Point + Promise to Save Time/Money
                        </li>
                        <li>
                            Tease Emotional Discovery Story
                        </li>
                        <li>
                            Tease Unique Mechanism Behind Solution
                        </li>
                        <li>
                            Tease Contrarian Nature of Mechanism 
                            (This Flies in the Face of What You’ve Been Told Before)
                        </li>
                        <li>
                            Working in “Fascinations” as Incentive For Continuing With Copy (I’ll
                            Answer This Riddle For You)
                        </li>
                        <li>
                            Briefly Address Skepticism
                        </li>
                        <li>
                            Briefly Mention Credibility Builders
                        </li>
                        <li>
                            Qualifiers – Who This Works For. Is It For Everyone? Is It For a Certain
                            Subset? Speak to Your Market.
                        </li>
                        <li>
                            Include a Few Broad Testimonials if Available (About Benefits But Don’t
                            Give Away Product)
                        </li>
                    </ul>
                </div>

                <div class="outlinePart">
                    <h2>
                        II. BACKGROUND STORY
                    </h2>
                    <ul>
                        <li>
                            Who I Am + Credibility Builders When Appropriate (ie. A Doctor or Expert)
                        </li>
                        <li>
                            “Me or Someone Close to Me Was Just Like You (In Pain)” – Here’s The
                            Emotional Story About It
                        </li>
                        <li>
                            Traditional Solutions & Advice Not Working
                        </li>
                        <li>
                            Trigger Event – Problem or Pain Point Escalated to Where Avatar Realizes
                            Something MUST Change
                        </li>
                        <li>
                            Search for Truth/Answers
                        </li>
                        <li>
                            Optional: Meets Wise “Sensei” Type Who Promises to Reveal the Truth
                            That’s Been Hidden.
                        </li>
                    </ul>
                </div>

                <div class="outlinePart">
                   <h2>III. UNIQUE MECHANISM OF THE PROBLEM</h2>
                   <ul>
                        <li>Explaining the “Real Cause” of the Problem; You’ve Had 99% of the Answer</li>
                        <li>But This is the Missing 1%</li>
                        <li>Should Be Surprising, Possibly Even Counterintuitive</li>
                        <li>Backed by Credibility and Proof Elements</li>
                   </ul>
                </div>

                <div class="outlinePart">
                    <h2>IV. UNIQUE MECHANISM OF THE SOLUTION</h2>
                    <ul>
                        <li>
                            Now That You Know the Real Cause of the Problem, This is the “Real
                            Solution” on a MACRO level.
                        </li>
                        <li>This Should Be Logically Connected to the Problem</li>
                        <li>
                            For Example: If Bad Bacteria is Causing Your Weight Gain, the Solution is
                            a Novel Way to Rid Your Gut of Bad Bacteria.
                        </li>
                        <li>
                            Once They Have the MACRO Solution (A Theory) – They Dig Deep To Prove
                            The Theory (And Get Into The MICRO).
                        </li>
                        <li>
                            Backed By Credibility and Proof Elements, Including Citations and Scientific Sources.
                        </li>
                    </ul>
                </div>
                <div class="outlinePart">
                    <h2>V. PRODUCT BUILDUP + REVEAL</h2>
                    <ul>
                        <li>
                            Now That Avatar Knows The Solution, He Looks For An “Out-of-the-Box”
                            Version; Something That Will Just End His Quest and Solve The Problem
                            Right There
                        </li>
                        <li>
                            But Discovers That Out-of-the-Box Is Flawed
                        </li>
                        <li>
                            Has to Do It Himself And Create Novel New Solution
                        </li>
                        <li>
                            Starts Testing It or Working On It. There Are Problems and Setbacks
                        </li>
                        <li>
                            But Eventual Success/Breakthrough
                        </li>
                        <li>
                            Proof Product Works
                        </li>
                        <li>
                            Others Asking For It
                        </li>
                        <li>
                            PRODUCT Is Born!
                        </li>
                    </ul>
                </div>

                <div class="outlinePart">
                    <h2>VI. CLOSE</h2>
                    <ul>
                        <li>
                            Product Details (What’s Included, What Makes it Special, Unique Selling Propositions)
                        </li>
                        <li>
                            Discuss and Dismiss Other Alternatives (Expensive, Ineffective, Side-Effects, Poor Quality, Unproven)
                        </li>
                        <li>
                            Keep Building Up Value of -PRODUCT-
                        </li>
                        <li>
                            Additional Testimonials
                        </li>
                        <li>
                            How to Use The Product
                        </li>
                        <li>
                            Optional Urgency – Powers That Be May Want to Stop Me From Sharing This At Any Time
                        </li>
                        <li>
                            Scarcity: Demand Is High, Supplies Are Limited, Out-of-Stocks Are Common
                        </li>
                        <li>
                            Personal Mission of Avatar to Make Things Better – Tied to Emotion
                        </li>
                        <li>
                            Price Justification & Reveal – Other “Solutions” Are More Expensive &Consequences of Inaction are Costly (Cost Can Be Either Material or Immaterial)
                        </li>
                        <li>
                            This Solution is Better and Will Save You Money, It’s Normally $X Which is Bargain, But Right Now You Can Get It For Just $Y!
                        </li>
                        <li>
                            Smart People Buy More
                        </li>
                        <li>
                            First Call to Action
                        </li>
                        <li>
                            What Happens After You Click The Button
                        </li>
                        <li>
                            Optional: Valuable Free Bonuses Revealed
                        </li>
                        <li>
                            Guarantee – You’ll Most Likely Have a Great Experience, But If For Any Reason You Don’t, No Risk and No Hassle
                        </li>
                        <li>
                            Second Call to Action
                        </li>
                        <li>
                            Two Choices – You Can Go On Suffering, Or You Can Take Action Today and Change Your Life forever; The Choice Is Yours
                        </li>
                        <li>
                            Urgency 2 – But You Really Must Hurry As This is The End of the Presentation And There’s No Guarantee How Long Offer Will Be Available
                        </li>
                        <li>
                            Third Call to Action
                        </li>
                        <li>
                            Thank You For Watching
                        </li>
                    </ul>
                </div>

                <div class="outlinePart">
                    <h2>
                        VII. FAQS
                    </h2>
                    <ul>
                        <li>
                            Back to Being Their Friend; Helping To Clear Up Any Confusion They May Have
                        </li>
                        <li>
                            Reminding Them of What Product Is, What It’s Used For, Importance of Taking Action Today, Terms of Guarantee, and How to Buy!
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

<style>
h2 {
    @apply text-4xl;
}
ul {
    /* @apply list-inside; */
    @apply pl-5;
}
ul li {
    @apply list-disc;
}
li {
    @apply text-lg;
}
.outlinePart {
    @apply mb-4;
}
.outlinePart h2 {
    @apply mb-2;
}
.editingContainer{
    /* width: 100vw; */
    /* height: 100vh; */
    display: flex;
    flex-direction: row;
    /* position: absolute; */
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
}
label{
    font-weight:bold;
}
#copyOutline {
    overflow-y: scroll;
    max-height: 100vh;
}
.editorContainer{
    flex: 1;
    width: 50%;
    max-height: 83vh;
}
.ql-editor{
    overflow-y:scroll;
}
.tabContainer{
    display: flex;
    flex-direction: row;
}
.tab{
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
}
.briefForm{
    padding-left: 5%;
    padding-right: 5%;
}
.active {
    border: black 1px solid;
    border-radius: 5px 5px 0px 0px;
}
.inactive{
    color: rgba(255, 255, 255, 0.657);
    background-color: peachpuff;
}
.editor{
    /* border: black 1px solid; */
    /* font-family: monospace; */
    /* font-size: x-large; */
    @apply px-1
}
.shortBriefInput{
    width: 95%;
    @apply border-black;
    @apply rounded;
    @apply border-2;
    display: block;

}

.activeEditor{
    height:100%;
}

.inactiveEditor{
    display: none;
}
/* main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
} */

h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
}

#brief{
    width: 100%;
}
#mechanism {
    width: 100%;
}

/* @media (min-width: 640px) {
    main {
        max-width: none;
    }
} */
</style>